import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SettingsNavigation } from '@studio/navigation';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import {
  FLOW_LOCALIZATION,
  INTEGRATION_LISTING_PAGE_REDESIGN,
  MOBILE_FLOWS,
  selectFeature,
} from 'next/entities/features';

const SettingsNavigationProvider = ({
  hasFlowLocalization,
  hasIntegrationPageRedesign,
  hasMobileFlows,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const navigationFeatureFlags = useMemo(
    () => ({
      hasFlowLocalization,
      hasIntegrationPageRedesign,
      hasMobileFlows,
    }),
    [hasFlowLocalization, hasIntegrationPageRedesign, hasMobileFlows]
  );

  return (
    <SettingsNavigation
      NavLink={NavLink}
      featureFlags={navigationFeatureFlags}
      matchExactRoutes
      currentPath={pathname}
      onClickBackArrow={() => history.push('/')}
    />
  );
};

SettingsNavigationProvider.propTypes = {
  hasFlowLocalization: PropTypes.bool,
  hasIntegrationPageRedesign: PropTypes.bool,
  hasMobileFlows: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    hasFlowLocalization: selectFeature(state, FLOW_LOCALIZATION),
    hasIntegrationPageRedesign: selectFeature(
      state,
      INTEGRATION_LISTING_PAGE_REDESIGN
    ),
    hasMobileFlows: selectFeature(state, MOBILE_FLOWS),
  };
};

export default connect(mapStateToProps)(SettingsNavigationProvider);
